import { Box, Grid, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";

import HeadingSection from "../components/custom/HeadingSection";
import { ServiceCard } from "../components/custom/ServiceCard";
import OutlineButton from "../components/custom/OutlineButton";
import TestimonialSwiper from "../components/custom/TestimonialSwiper";
import AboutSection from "../components/custom/AboutSection";
import FilledButton from "../components/custom/FilledButton";
import Features from "../components/custom/Features";
import { Helmet } from "react-helmet-async";

const HomeScreen = () => {
  const services = [
    {
      src: "../assets/cyber.png",
      title: "Cyber Cafe Services",
      desc: "Quick and easy help with document processing and online form submissions, including government forms and basic services. We handle everything – from new ID applications to booking train tickets.",
    },
    {
      src: "../assets/graphics.png",
      title: "Graphic Design",
      desc: "We bring your ideas to life with custom graphic design services, perfect for personal projects, branding, or events. Our designs are tailored to meet your unique needs and make a lasting impression.",
    },
    {
      src: "../assets/typing.png",
      title: "Typing Services",
      desc: "Fast and accurate typing services for all your document needs. From resumes to reports, we ensure precision and professionalism, saving you time and effort.",
    },
  ];
  return (
    <>
      {/* Helmet */}
      <Helmet>
        <title>
          Glory Online Cyber Cafe - Digital Services & Graphic Design 24/7
        </title>
        <meta
          name="description"
          content="Glory Online Cyber Cafe offers 24/7 digital services, graphic design, and typing support. Fast, affordable, and professional solutions for all your online service needs."
        />
        <link rel="canonical" href="https://www.gloryservices.work/" />
      </Helmet>

      {/* Hero Section */}
      <Box
        bgImage='url("../assets/heroHome1.jpg")'
        height={{ base: "400px", md: "600px" }}
        w="full"
        backgroundSize="100% 100%"
        display="flex"
        alignItems="center"
      >
        <Stack px={{ base: "5", md: "10", lg: "20" }} gap={5}>
          <Flex
            color="white"
            w={{ base: "xs", md: "2xl", lg: "3xl" }}
            gap={{ base: "3", md: "3" }}
            direction="column"
          >
            <Heading
              as="h1"
              size={{ base: "2xl", md: "6xl", lg: "6xl" }}
              fontWeight="semibold"
            >
              Simplifying Digital Tasks, One Service at a Time
            </Heading>
            <Text fontSize={{ base: "sm", md: "lg" }}>
              Offering Reliable Online Services, Graphic Design, and Typing
              Services for You.
            </Text>
          </Flex>

          <FilledButton
            title="GET STARTED"
            url="/services"
            color="#a81414"
            bgColor="#fff"
          />
        </Stack>
      </Box>

      {/* Welcome Section */}
      <HeadingSection
        title="WELCOME"
        desc="Step into a world of convenience with our 24/7 digital services. Whether you need professional graphic design, document typing, or other essential cyber café services, we’re here to help."
      />

      {/* Services Card */}
      <Stack alignItems="center">
        <Grid
          templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)" }}
          px={{ base: "10", md: "10", lg: "20" }}
          gap={{ base: "5", md: "5", lg: "10" }}
          justifyContent="center"
          pb={10}
        >
          {services.map((service) => (
            <ServiceCard
              src={service.src}
              title={service.title}
              desc={service.desc}
            />
          ))}
        </Grid>
        <OutlineButton title="VIEW ALL SERVICES" url="/services" />
      </Stack>

      {/* Features */}
      <Features />

      {/* About */}
      <AboutSection />

      {/* Testimonials */}
      <Box
        bgImage='url("../assets/testimonialBG1.jpg")'
        height={{ base: "500px", md: "700px", lg: "800px" }}
        w="full"
        backgroundSize="100% 100%"
        mb={20}
        display="flex"
        alignItems="center"
        px={{ base: "10", md: "10", lg: "20" }}
      >
        <TestimonialSwiper />
      </Box>

      {/* Get in Touch */}
      <Stack
        w={{ base: "xs", md: "3xl", lg: "4xl" }}
        textAlign="center"
        alignItems="center"
        m="auto"
        lineHeight="1"
        mb={20}
        gap={10}
      >
        <Text
          fontWeight="bold"
          fontSize={{ base: "4xl", md: "7xl", lg: "8xl" }}
        >
          Reach Out for Quick, Hassle-Free <br /> Service!
        </Text>
        <FilledButton title="CONNECT NOW" px="10" url="/contact" />
      </Stack>
    </>
  );
};

export default HomeScreen;
